/** Local-only activity ids for optimistic URL paste pins (never persisted). */
export const PENDING_URL_ACTIVITY_PREFIX = 'pending-url:';

export function isPendingUrlActivityId(activityId) {
  return String(activityId || '').startsWith(PENDING_URL_ACTIVITY_PREFIX);
}

export function createPendingUrlActivityId() {
  return `${PENDING_URL_ACTIVITY_PREFIX}${Date.now().toString(36)}_${Math.random()
    .toString(36)
    .slice(2, 8)}`;
}
